export const baseURL =process.env.REACT_APP_BASE_URL;
export const env = process.env.REACT_APP_ENV;
export const googlePlacesApiKey = process.env.REACT_APP_GOOGLE_PLACES_API_KEY;
